import React from "react";
import Form from "../Form/Form";

const Home: React.FC = () => {
    return (
        <div>
            <Form />
        </div>
    );
};

export default Home;
